<app-main-layout-spacer>
  <app-common-id-sign-out-header></app-common-id-sign-out-header>

  <app-wrapper size="lg">
    <app-content-row>
      <app-article-content>
        <app-article-content-head>特定商取引法に基づく表示</app-article-content-head>
        <app-document-theme-default>
          <div>
            <table>
              <tr>
                <th>1. 事業者の名称、住所、電話番号</th>
                <td>
                  <ul class="mt-0">
                    <li>事業者名 株式会社旺文社</li>
                    <li>事業者の住所 〒162-8680　東京都新宿区横寺町５５</li>
                    <li>電話番号　03-3266-6448　（平日10時～16時／12時～13時を除く）</li>
                    <li>メールアドレス　nyushi-digi@cs.obunsha.co.jp</li>
                    <li>責任者名　津山　隆平</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>2. 販売価格</th>
                <td>商品ページをご覧ください。</td>
              </tr>
              <tr>
                <th>3. 対価以外に必要となる費用</th>
                <td>
                  サービス利用に必要な端末、インターネット接続料金、通信料金はお申込者の負担となります。商品 /
                  サービスの特性上、送料は発生いたしません。
                </td>
              </tr>
              <tr>
                <th>4. 商品代金の支払方法・支払時期</th>
                <td>
                  <ul class="mt-0">
                    <li>
                      支払方法：クレジットカード決済(Visa / Master card / JCB / American Express)、コンビニ決済(ファミリーマート / ローソン
                      / ミニストップ / セイコーマート)
                    </li>
                    <li>
                      支払時期：<br />
                      ・クレジットカード決済...購入時(引落日はご契約されているクレジットカード会社により異なります。)<br />
                      ・コンビニ決済...ご注文日から7日以内にお支払いください。<br />
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>5. 商品の引渡時期</th>
                <td>
                  購入手続きが完了次第、利用可能な状態となります。
                </td>
              </tr>
              <tr>
                <th>6. 返品、解約等に関する事項</th>
                <td>デジタルコンテンツの特性上、購入確定後の返品・交換には応じられません。</td>
              </tr>
              <tr>
                <th>7. 動作環境</th>
                <td>サービスをご利用いただける推奨動作環境は、ヘルプページをご確認ください。</td>
              </tr>
            </table>
          </div>
        </app-document-theme-default>
      </app-article-content>
    </app-content-row>
  </app-wrapper>

  <app-common-id-footer></app-common-id-footer>
</app-main-layout-spacer>
